import { mockProviders } from '../app/core/mock/mock.providers';

export const environment = {
  defaultLanguage: 'pl',
  languages: ['pl', 'en'],
  languageFlag: {
    en: 'gb',
    pl: 'pl'
  },
  themeCookie: 'master-is-theme-light',
  contrastCookie: 'master-is-theme-contrast',
  contrastPresetCookie: 'master-contrast-theme',
  sizeCookieName: 'master-theme-size',
  defaultSize: '16px',
  sizeStep: 2,
  minSize: 10,
  maxSize: 30,
  apiUrl: 'https://mock.local/api',
  useMocks: true,
  mockProviders,
  keycloak: {
    url: 'https://mock.local/keycloak',
    realm: 'ksiegowskaz-master',
    clientId: 'ksiegowskaz-master-frontend',
  },
};
